import * as Icons from "lucide-react";
import { STATUS_META } from "./reviewMeta";

export function StatusDot({ status, size = "h-4 w-4" }) {
  const m = STATUS_META[status] || STATUS_META.not_reviewed;
  const I = Icons[m.icon] || Icons.Circle;
  return <I className={`${size} ${m.cls} shrink-0`} />;
}
